import { HTTP } from "@/common/http-common";
import properties from "@/properties";

const RESOURCE_NAME = "entities/files";

export default {
  async save(entity) {
    if (entity.id) {
      throw "File already exists";
    } else {
      return (
        await HTTP.post(`${RESOURCE_NAME}`, entity, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      ).data;
    }
  },
};
